var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4732_572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.96 3.57025L0.586054 3.57025C0.262461 3.57025 0.000116348 3.8326 0.000116348 4.15619V7.33002C0.000116348 7.56064 0.135391 7.76978 0.345743 7.86439C1.18555 8.24209 1.7282 9.08037 1.7282 9.99998C1.7282 10.9196 1.18555 11.7579 0.345743 12.1356C0.135391 12.2301 0.000116348 12.4393 0.000116348 12.6699V15.8438C0.000116348 16.1674 0.262461 16.4297 0.586054 16.4297H13.96V3.57025Z",
    fill: "#572148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15.8438V12.67C20 12.4394 19.8647 12.2302 19.6544 12.1356C18.8146 11.7579 18.272 10.9196 18.272 10C18.272 9.08041 18.8146 8.24213 19.6544 7.86443C19.8647 7.76982 20 7.56064 20 7.33002V4.15619C20 3.8326 19.7377 3.57025 19.4141 3.57025L15.1317 3.57025V16.4298H19.4141C19.7377 16.4298 20 16.1674 20 15.8438Z",
    fill: "#572148"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4732_572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTicketIcon);
export default __webpack_public_path__ + "static/media/NewTicketIcon.4482e9ca.svg";
export { ForwardRef as ReactComponent };